// SHARED-001: Base enums and common types
// All base enums and interfaces shared across phases

export enum ElementType {
  RED = 'RED',
  BLUE = 'BLUE',
  GREEN = 'GREEN',
  YELLOW = 'YELLOW',
  PURPLE = 'PURPLE',
}

export enum AgentType {
  BACKEND = 'BACKEND',
  FRONTEND = 'FRONTEND',
  TESTING = 'TESTING',
  DEVOPS = 'DEVOPS',
  HACKER = 'HACKER',
}

export enum SkillEffectType {
  DAMAGE = 'DAMAGE',
  HEAL = 'HEAL',
  BUFF_ATK = 'BUFF_ATK',
  BUFF_DEF = 'BUFF_DEF',
  DEBUFF_ENEMY = 'DEBUFF_ENEMY',
  BOARD_CHANGE = 'BOARD_CHANGE',
  COOLDOWN_REDUCE = 'COOLDOWN_REDUCE',
}

export enum HardwareType {
  CPU = 'CPU',
  GPU = 'GPU',
  TPU = 'TPU',
  COOLER = 'COOLER',
  PSU = 'PSU',
}

export type Rarity = 1 | 2 | 3 | 4 | 5 | 6;

export interface SkillEffect {
  type: SkillEffectType;
  value: number;
  duration: number; // 0 = instant, >0 = lasting turns
  target: 'self' | 'team' | 'enemy' | 'board';
}

export interface HardwareSpecialEffect {
  type: 'REDUCE_CD' | 'REDUCE_OVERLOAD_THRESHOLD';
  value: number;
}
